export const learnerDashboardData = {
  products: [
    {
      category_slug: 'programming',
      title: 'Programming',
      products: [
        {
          product_name: 'Full Stack Bootcamp',
          expiry_date: '2026-12-31',
          is_expired: false,
          access_source: 'purchase',
          sub_categories: [
            {
              title: 'Frontend',
              order: 2,
              is_displayed: true,
              courses: [
                {
                  course_id: 'course-v1:Alnafi+FE201+2026', order: 2, is_active: true, access_type: 'paid',
                },
                {
                  course_id: 'course-v1:Alnafi+FE101+2026', order: 1, is_active: true, access_type: 'paid',
                },
              ],
            },
            {
              title: 'Backend',
              order: 1,
              is_displayed: true,
              courses: [
                {
                  course_id: 'course-v1:Alnafi+BE101+2026', order: 1, is_active: false, access_type: 'paid',
                },
              ],
            },
            {
              title: 'Deprecated Track',
              order: 3,
              is_displayed: false,
              courses: [
                {
                  course_id: 'course-v1:Alnafi+OLD101+2020', order: 1, is_active: false, access_type: 'paid',
                },
              ],
            },
          ],
        },
        {
          product_name: 'Expired Bundle',
          expiry_date: '2024-01-01',
          is_expired: true,
          access_source: 'demo',
          sub_categories: [
            {
              title: 'Basics',
              order: 1,
              is_displayed: true,
              courses: [
                {
                  course_id: 'course-v1:Alnafi+BASIC101+2023', order: 1, is_active: false, access_type: 'demo',
                },
              ],
            },
          ],
        },
        {
          product_name: null,
          expiry_date: null,
          is_expired: false,
          access_source: 'demo',
          sub_categories: [],
        },
      ],
    },
  ],
  direct_categories: [
    {
      category_slug: 'data-science',
      title: 'Data Science',
      sub_categories: [
        {
          title: 'Statistics',
          order: 1,
          is_displayed: true,
          courses: [
            {
              course_id: 'course-v1:Alnafi+STATS101+2026', order: 1, is_active: true, access_type: 'free',
            },
          ],
        },
      ],
    },
  ],
  others: {
    title: 'Others',
    courses: [
      {
        course_id: 'course-v1:Alnafi+MISC101+2026', order: 1, is_active: true, access_type: 'free',
      },
      {
        course_id: 'course-v1:Alnafi+MISC102+2026', order: 2, is_active: false, access_type: 'free',
      },
    ],
  },
  unclassified: [],
};

export const emptyLearnerDashboardData = {
  products: [],
  direct_categories: [],
  others: null,
  unclassified: [],
};

export default {
  learnerDashboardData,
  emptyLearnerDashboardData,
};
